<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                </nav>
            </b-col>
        </b-row>
        </base-header>
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col cols="12">
                    <div class="card-wrapper">
                        <b-card no-body>
                            <b-tabs pills card>
                                <b-tab :title="language_terms['BASIC_INFORMATION']" active>
                                    <b-card-text>
                                        <card>
                                            <div slot="header">
                                                <h3 >{{language_terms['BASIC_INFORMATION']}} 
                                                    <span v-if="asset_classification.code">({{asset_classification.code}})</span>
                                                </h3>
                                            </div>
                                            <b-row>
                                                <b-col cols="12" md="12">
                                                    <base-input :label="language_terms['CODE']" v-model="asset_classification.code" :disabled="!is_edit"></base-input>
                                                </b-col>
                                                <b-col cols="12" md="12">
                                                    <base-input :label="language_terms['NAME']" v-model="asset_classification.name" :disabled="!is_edit"></base-input>
                                                </b-col>

                                                <b-col cols="12" md="12" v-if="is_edit" class="mb-3">
                                                    <label class="form-control-label">{{language_terms['ASSET_PROTOCOL']}}</label>
                                                    <multiselect
                                                        open-direction="bottom"
                                                        :placeholder="language_terms['SEARCH']"
                                                        label="name"
                                                        track-by="code"
                                                        :options="asset_protocols"
                                                        text-field="name"
                                                        :multiple="false"
                                                        v-model="asset_classification.asset_protocol"
                                                        :taggable="false"
                                                        :disabled="!is_edit"
                                                        ></multiselect>
                                                </b-col>
                                                <b-col cols="12" md="12" v-else>
                                                    <base-input :label="language_terms['ASSET_PROTOCOL']" v-model="asset_classification.assetprotocol_name" disabled></base-input>
                                                </b-col>
                                                <b-col cols="12">
                                                    <base-input :label="language_terms['REMARKS']">
                                                        <textarea
                                                        class="form-control"
                                                        id="exampleFormControlTextarea1"
                                                        rows="3"
                                                        v-model="asset_classification.remarks"
                                                        :disabled="!is_edit">
                                                        </textarea>
                                                    </base-input>
                                                </b-col>
                                            </b-row>
                                        </card>

                                        <card>
                                            <div slot="header">
                                                <h3 >{{language_terms['DEPRECIATION']}} 
                                                    <!-- <span v-if="asset_classification.code">({{asset_classification.code}})</span> -->
                                                </h3>
                                            </div>
                                            <b-row>
                                                <b-col cols="12" md="6" v-if="is_edit" class="mb-3">
                                                    <label class="form-control-label">{{language_terms['DEPRECIATION_EXPENSE']}}</label>
                                                    <multiselect
                                                        open-direction="bottom"
                                                        :placeholder="language_terms['SEARCH']"
                                                        label="display_name"
                                                        track-by="code"
                                                        :options="accounts_expenses"
                                                        text-field="display_name"
                                                        :multiple="false"
                                                        v-model="asset_classification.account_depreciation_expense"
                                                        :taggable="false"
                                                        :disabled="!is_edit"
                                                        >
                                                    </multiselect>

<!--
                                                    <el-select
                                                        v-model="asset_classification.account_depreciation_expense"
                                                        filterable
                                                        :placeholder="language_terms['SEARCH']"
                                                        :disabled="!is_edit">
                                                        <el-option
                                                            v-for="option in accounts_expenses"
                                                            :key="option.code"
                                                            :label="option.code"
                                                            :value="option.code">
                                                        </el-option>
                                                    </el-select>                                                    
-->

                                                </b-col>
                                                <b-col cols="12" md="6" v-else>
                                                    <base-input :label="language_terms['DEPRECIATION_EXPENSE']" v-model="asset_classification.account_depreciation_expense_name" disabled></base-input>
                                                </b-col>

                                                <b-col cols="12" md="6" v-if="is_edit" class="mb-3">
                                                    <label class="form-control-label">{{language_terms['ACCUMULATED_EXPENSE']}}</label>
                                                    <multiselect
                                                        open-direction="bottom"
                                                        :placeholder="language_terms['SEARCH']"
                                                        label="display_name"
                                                        track-by="code"
                                                        :options="accounts_assets"
                                                        text-field="display_name"
                                                        :multiple="false"
                                                        v-model="asset_classification.account_accumulated_expense"
                                                        :taggable="false"
                                                        :disabled="!is_edit"
                                                        ></multiselect>
                                                </b-col>
                                                <b-col cols="12" md="6" v-else>
                                                    <base-input :label="language_terms['ACCUMULATED_EXPENSE']" v-model="asset_classification.account_accumulated_expense_name" disabled></base-input>
                                                </b-col>

                                            </b-row>
                                        </card>
                                    </b-card-text>
                                    <div class="floating-bar">
                                        <div class="floating-bar-container" align="center">
                                            <b-button-group>
                                                <b-button class="transparent-btn" v-if="!is_edit" @click ="clickOnEdit()">
                                                    <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                                                </b-button>
                                                <b-button class="transparent-btn" v-if="is_edit" @click="save()">
                                                    <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                                                </b-button>
                                                <b-button class="transparent-btn" v-if="is_edit" @click="cancel()">
                                                    <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                                                </b-button>
                                                <b-button class="transparent-btn" v-if="$route.params.id != '_new'">
                                                    <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </b-card>

                        
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

export default 
{
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            asset_classification_filter: state => state.assetClassifications.filter,
            asset_classification_data: state=> state.assetClassifications.asset_classification_data,
            is_created:state =>state.assetClassifications.is_created,
            is_updated:state =>state.assetClassifications.is_updated,
            asset_protocols:state => state.assetProtocols.active_list,
            accounts_for_fy:state=> state.accounts.accounts_for_fy,
        })
    },
    components:{
        Loading
    },
    data(){
        return{
            loading:false,
            is_edit:false,
            asset_classification:{
                code:"",
                rfid:{}
            },
            accounts_expenses:{},
            accounts_assets:{},
        }
    },
    methods:{
        cancel() 
        {
            location.reload();
        },        
        async getAllAccountsForFY()
        {
            await this.$store.dispatch("accounts/getAccountForFys", {type:"EXPENSES"})
            this.accounts_expenses = this.accounts_for_fy
            
            await this.$store.dispatch("accounts/getAccountForFys", {type:"ASSETS"})
            this.accounts_assets = this.accounts_for_fy
        },
        async searchAssetClassifications()
        {
            this.loading = true
            let filter = {keyword:"",active_only:"1"}
            if(this.asset_classification_filter)
            {
                filter = this.asset_classification_filter
            }
            await this.$store.dispatch('assetClassifications/quickSearch', filter)

            this.loading = false
        },
        async save()
        {
            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("assetClassifications/create", this.asset_classification);
                if(this.is_created)
                {
                    await this.searchAssetClassifications()
                    this.$router.push("/assetclassifications-management/asset-classifications")
                }
            }
            else
            {
                await this.$store.dispatch("assetClassifications/update", this.asset_classification);
                if(this.is_updated)
                {
                    await this.searchAssetClassifications()
                    this.$router.push("/assetclassifications-management/asset-classifications")
                }
            }
        },
        clickOnEdit()
        {
            this.is_edit = true
        },
        async retrieveAsset(asset_classification_code)
        {
            this.loading=true
            this.getAllAccountsForFY()
            await this.$store.dispatch("assetClassifications/fetch", {code:asset_classification_code});
            this.loading=false
        }
    },
    async mounted()
    {
        this.loading = true

        this.getAllAccountsForFY()
        if(this.$route.params.id == '_new')
        {
            this.is_edit = true
        }
        else
        {
            await this.retrieveAsset(this.$route.params.id)
            this.asset_classification = this.asset_classification_data
        }

        await this.$store.dispatch("assetProtocols/listActive", {})
        //await this.$store.dispatch("accounts/getAccountForFys", {fy:'2022'})
        //this.account_list = this.accounts_for_fy

        this.loading = false
    },
}
</script>
